import { firestore } from '../firebase';
import { helpTopics as fallbackHelpTopics, HelpTopic } from './FAQContent';
import { helpCenterConfigPath, normalizeHelpCenterTopics } from './FAQContentSchema';

type HelpCenterSource = 'firestore' | 'fallback';

export type HelpCenterContentState = {
  topics: HelpTopic[];
  source: HelpCenterSource;
  isLoading: boolean;
  error: string | null;
};

export { helpCenterConfigPath, normalizeHelpCenterTopics };

export async function fetchPublishedHelpTopics(): Promise<HelpTopic[] | null> {
  const snapshot = await firestore.collection('publicAppConfig').doc('helpCenter').get();

  if (!snapshot.exists) {
    return null;
  }

  return normalizeHelpCenterTopics(snapshot.data()?.topics);
}

export function subscribeToPublishedHelpTopics(
  onChange: (topics: HelpTopic[] | null) => void,
  onError: (error: Error) => void
) {
  return firestore
    .collection('publicAppConfig')
    .doc('helpCenter')
    .onSnapshot((snapshot) => {
      if (!snapshot.exists) {
        onChange(null);
        return;
      }

      onChange(normalizeHelpCenterTopics(snapshot.data()?.topics));
    }, onError);
}

export function createFallbackHelpCenterState(): HelpCenterContentState {
  return {
    topics: fallbackHelpTopics,
    source: 'fallback',
    isLoading: false,
    error: null,
  };
}
